import { Empty, Spin } from 'antd'
import AntdAvatar from 'components/Avatar'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import Select from 'components/Select/index'
import { StyledCheckbox } from 'components/UIComponents/FilterCheckBoxComp/style'
import ReplaceIcon from 'components/icons/ReplaceIcon'
import {
  CollageDetailsFlex,
  CollageNameFlex,
  CollegeCity,
  CollegeCitys,
  CollegeNameDiv,
  EmtyWrapper,
  FooterFlex,
  HeaderFlex,
  SearchDiv,
} from 'modules/Exp-Candidates/ViewDriveRole/AddInterviewerDrawer/style'
import React, { Fragment, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import InderViewerStatus from '../InderViewerStatus/index'
import { CollageDetailsFlexing } from '../style'

const ReplaceDrawer = ({
  setAddInterviewerDrawer,
  getInterviewerList,
  getDriveInterviewerList,
  interViewerList,
  driveInterViewerList,
  setChecked,
  checked,
  interViewerId,
  driveId,
  setAddReplaceDrawer,
  addReplaceDrawer,
  selectedInterviewerId,
  setSelectedInterViewerId,
  newInterViewer,
  setNewInterViewer,
}) => {
  const params = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [search, setSearch] = useState('')

  const getInterviewer = async (searchValue, expcandidatesId) => {
    setIsLoading(true)
    await getInterviewerList(searchValue, expcandidatesId)
    setIsLoading(false)
  }

  const getDriveInterviewer = async driveId => {
    await getDriveInterviewerList(driveId)
  }

  useEffect(() => {
    getInterviewer(search, params.expcandidatesId)
  }, [search, params.expcandidatesId])

  useEffect(() => {
    getDriveInterviewer(driveId)
  }, [driveId])

  const onSelectInterviewer = data => {
    setSelectedInterViewerId(data?.length !== 0 ? [data[data?.length - 1]] : [])
  }

  const onSearchInterviewer = data => {
    setSearch(data)
  }

  const handleCheckboxChange = (value, data) => {
    if (checked === value) {
      setChecked(null)
      setNewInterViewer()
    } else {
      setChecked(value)
      setNewInterViewer(data)
    }
  }

  const onClose = () => {
    setAddReplaceDrawer(false)
    setSelectedInterViewerId([])
  }

  const handleConfirm = () => {
    setAddReplaceDrawer(false)
    setAddInterviewerDrawer(true)
    setChecked(null)
  }

  const handleClose = () => {
    setNewInterViewer()
    setAddReplaceDrawer(false)
    setChecked(null)
  }

  const content = () => {
    return (
      <>
        <HeaderFlex spaceBetween centerVertically>
          <SearchDiv>
            <Select
              filterOption={true}
              isSearchSelect={true}
              placeholder="Search Members"
              valueParam="_id"
              nameParam="first_name"
              lastNameParam="last_name"
              mode="multiple"
              onChange={onSelectInterviewer}
              value={selectedInterviewerId}
              optionLabelProp={'label'}
              menuItemSelectedIcon={''}
              showSearch={true}
              onSearch={onSearchInterviewer}
              onBlur={() => setSearch('')}
              notFoundContent={
                isLoading ? (
                  <CollageDetailsFlex alignCenter center isBoader={true}>
                    <Spin />
                  </CollageDetailsFlex>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={'Interviewer not found!'}
                  />
                )
              }
            />
          </SearchDiv>
        </HeaderFlex>
        {driveInterViewerList?.length > 0 ? (
          <Fragment>
            {driveInterViewerList?.map((interviewer, index) => {
              if (interViewerId === interviewer?._id) {
                return (
                  <CollageDetailsFlexing
                    key={index + 'drive'}
                    centerVertically
                    width={'100%'}
                  >
                    <Flex left gap={3}>
                      <AntdAvatar
                        size={36}
                        IconName={interviewer?.first_name
                          ?.charAt(0)
                          ?.toUpperCase()}
                      />
                      <CollageNameFlex>
                        <CollegeNameDiv>
                          {interviewer?.first_name} {interviewer?.last_name}
                        </CollegeNameDiv>
                        <CollegeCity>{interviewer?.email}</CollegeCity>
                      </CollageNameFlex>
                    </Flex>
                    <Flex alignCenter width={'10%'}>
                      <ReplaceIcon />
                    </Flex>
                    {newInterViewer ? (
                      <Flex alignCenter width={'40%'}>
                        <AntdAvatar
                          size={36}
                          IconName={
                            newInterViewer?.first_name
                              ?.charAt(0)
                              ?.toUpperCase() || ''
                          }
                        />
                        <CollageNameFlex>
                          <CollegeNameDiv>
                            {newInterViewer?.first_name || '-'}{' '}
                            {newInterViewer?.last_name}
                          </CollegeNameDiv>
                          <CollegeCity>
                            {newInterViewer?.email || '-'}
                          </CollegeCity>
                        </CollageNameFlex>
                      </Flex>
                    ) : (
                      <Flex alignCenter>
                        <AntdAvatar size={36} />
                      </Flex>
                    )}
                  </CollageDetailsFlexing>
                )
              }
            })}
            <div style={{ marginTop: '30px' }}>
              <CollegeNameDiv>Replacing With</CollegeNameDiv>
            </div>
            {interViewerList?.map(item => {
              if (interViewerId !== item?._id) {
                return (
                  <div key={item._id} style={{ marginTop: '30px' }}>
                    <CollageDetailsFlex spaceBetween centerVertically>
                      <Flex alignCenter>
                        <StyledCheckbox
                          key={item._id}
                          value={item.value}
                          checked={checked === item._id}
                          onChange={() => handleCheckboxChange(item._id, item)}
                          disabled={!item?.isAvailable}
                        />
                        <AntdAvatar
                          size={36}
                          IconName={item.first_name?.charAt(0)?.toUpperCase()}
                        />
                        <CollageNameFlex>
                          <CollegeNameDiv>
                            {item.first_name} {item.last_name}
                          </CollegeNameDiv>
                          <CollegeCitys>{item.email}</CollegeCitys>
                        </CollageNameFlex>
                      </Flex>
                      <InderViewerStatus is_available={item?.isAvailable} />
                    </CollageDetailsFlex>
                  </div>
                )
              }
            })}
          </Fragment>
        ) : (
          <EmtyWrapper center></EmtyWrapper>
        )}
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          width="88px"
          height="38px"
          text="Cancel"
          onClick={handleClose}
        />
        <Button.Primary
          width="95px"
          height="38px"
          text="Replace"
          onClick={handleConfirm}
        />
      </FooterFlex>
    )
  }

  return (
    <Drawer
      width="40%"
      title={'Replace Interviewer'}
      placement="right"
      visible={addReplaceDrawer}
      content={content()}
      footer={footer()}
      onClose={onClose}
      closable
    />
  )
}

export default ReplaceDrawer
